import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
import SchoolIcon from '@mui/icons-material/School';

export default function IMUUserCreate() {

  const [formData, setFormData] = useState({
    vendorName: '',
    vendorType: '',
    phoneNumber: '',
    email: '',
    address: '',
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { http } = Api();

  const validateForm = () => {
    const newErrors = {};

    if (!formData.vendorName.trim()) {
      newErrors.vendorName = 'Vendor name is required';
    } else if (formData.vendorName.trim().length < 3) {
      newErrors.vendorName = 'Vendor name must be at least 3 characters';
    }

    if (!formData.vendorType) {
      newErrors.vendorType = 'Please select a vendor type';
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!/^[6-9]\d{9}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Enter a valid 10-digit phone number';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    ) {
      newErrors.email = 'Enter a valid email address';
    }

    if (!formData.address.trim()) {
      newErrors.address = 'Address is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error('Please fix the errors before submitting');
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        vendor_name: formData.vendorName,
        user_type: formData.vendorType === 'teacher' ? 'T' : 'V',
        phone_number: formData.phoneNumber,
        email: formData.email,
        address: formData.address,
      };


      const response = await http.post('College/addVendor', payload);

      toast.success(response.data.message || 'Vendor created successfully');

      // Reset form after success
      setFormData({
        vendorName: '',
        vendorType: '',
        phoneNumber: '',
        email: '',
        address: '',
      });

      setErrors({});
    } catch (error) {
      if (error.response?.data?.errors) {
        // Laravel validation errors
        setErrors({
          vendorName: error.response.data.errors.vendor_name?.[0],
          vendorType: error.response.data.errors.user_type?.[0],
          phoneNumber: error.response.data.errors.phone_number?.[0],
          email: error.response.data.errors.email?.[0],
          address: error.response.data.errors.address?.[0],
        });
      }

      toast.error(
        error.response?.data?.message || 'Failed to create vendor'
      );
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleReset = () => {
    setFormData({
      vendorName: '',
      vendorType: '',
      phoneNumber: '',
      email: '',
      address: '',
    });
    setErrors({});
  };


  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Template>
        <div className="container mb-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-12 col-lg-8 col-xl-6">
              <div className="card shadow-lg border-0 rounded-4">
                <div className="card-body p-4 p-md-5">
                  {/* Header Section */}
                  <div className="text-center mb-4">
                    <div
                      className="d-inline-flex align-items-center justify-content-center  bg-primary rounded-circle mb-3"
                      style={{ width: '64px', height: '64px' }}
                    >
                      <i className="bi bi-person-plus-fill fs-2 text-white"></i>
                    </div>

                    <h2 className="fw-bold mb-2">Create New Vendor</h2>
                  </div>


                  {/* Form */}
                  <form onSubmit={handleSubmit}>
                    {/* Vendor Name Input */}
                    <div className="mb-4">
                      <label htmlFor="vendorName" className="form-label fw-semibold">
                        Vendor Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control form-control-lg ${errors.vendorName ? 'is-invalid' :  ''}`}
                        id="vendorName"
                        name="vendorName"
                        value={formData.vendorName}
                        onChange={handleInputChange}
                        placeholder="Enter vendor name"
                        disabled={isSubmitting}
                      />
                      {errors.vendorName && (
                        <div className="invalid-feedback">
                          {errors.vendorName}
                        </div>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="form-label fw-semibold">
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        maxLength={10}
                        name="phoneNumber"
                        className={`form-control form-control-lg ${errors.phoneNumber ? 'is-invalid' :  ''
                          }`}
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        placeholder="Enter phone number"
                        disabled={isSubmitting}
                      />
                      {errors.phoneNumber && (
                        <div className="invalid-feedback">{errors.phoneNumber}</div>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="form-label fw-semibold">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''
                          }`}
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Enter email address"
                        disabled={isSubmitting}
                      />
                      {errors.email && (
                        <div className="invalid-feedback">{errors.email}</div>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="form-label fw-semibold">
                        Address <span className="text-danger">*</span>
                      </label>
                      <textarea
                        name="address"
                        rows="3"
                        className={`form-control ${errors.address ? 'is-invalid' :  ''
                          }`}
                        value={formData.address}
                        onChange={handleInputChange}
                        placeholder="Enter address"
                        disabled={isSubmitting}
                      />
                      {errors.address && (
                        <div className="invalid-feedback">{errors.address}</div>
                      )}
                    </div>




                    {/* Vendor Type Selection */}
                    <div className="mb-4">
                      <label className="form-label fw-semibold mb-3">
                        Vendor Type <span className="text-danger">*</span>
                      </label>
                      <div className="row g-3">
                        {/* Teacher Option */}
                        <div className="col-6">
                          <input
                            type="radio"
                            className="btn-check"
                            name="vendorType"
                            id="teacher"
                            value="teacher"
                            checked={formData.vendorType === 'teacher'}
                            onChange={handleInputChange}
                            disabled={isSubmitting}
                          />
                          <label
                            className={`btn btn-outline-primary w-100 py-3 d-flex flex-column align-items-center ${errors.vendorType && !formData.vendorType ? 'border-danger' : ''}`}
                            htmlFor="teacher"
                          >
                            <i className="bi bi-person-video3 fs-2 mb-2"></i>
                            <span className="fw-semibold">Teacher</span>
                          </label>
                        </div>

                        {/* Vendor Option */}
                        <div className="col-6">
                          <input
                            type="radio"
                            className="btn-check"
                            name="vendorType"
                            id="vendor"
                            value="vendor"
                            checked={formData.vendorType === 'vendor'}
                            onChange={handleInputChange}
                            disabled={isSubmitting}
                          />
                          <label
                            className={`btn btn-outline-primary w-100 py-3 d-flex flex-column align-items-center ${errors.vendorType && !formData.vendorType ? 'border-danger' : ''}`}
                            htmlFor="vendor"
                          >
                            <i className="bi bi-shop fs-2 mb-2"></i>
                            <span className="fw-semibold">Vendor</span>
                          </label>
                        </div>
                      </div>
                      {errors.vendorType && (
                        <div className="text-danger small mt-2">
                          {errors.vendorType}
                        </div>
                      )}
                    </div>

                    {/* Action Buttons */}
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-4 pt-3">
                      <button
                        type="button"
                        className="btn btn-outline-secondary px-4"
                        onClick={handleReset}
                        disabled={isSubmitting}
                      >
                        Reset
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary px-4"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Creating...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check-circle me-2"></i>
                            Create Vendor
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>



            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
